"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsBellIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _RoundButton = require("../RoundButton");

var _atoms = require("../../atoms");

require("./NotificationsBellIcon.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var NotificationsBellIcon = function NotificationsBellIcon(_ref) {
  var noOfNewMessages = _ref.noOfNewMessages,
      dotColor = _ref.dotColor,
      onBellIconClick = _ref.onBellIconClick,
      className = _ref.className;
  var color = dotColor ? dotColor : _atoms.Color.Error;
  var isMoreThan9 = noOfNewMessages > 9;
  var cname = 'notifications-bell-icon';

  if (className) {
    cname += ' ' + className;
  }

  var additionalStyles = {
    background: "var(--".concat(color, ")")
  };
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: cname
  }, /*#__PURE__*/_react.default.createElement(_RoundButton.RoundButton, {
    trkAction: "".concat(noOfNewMessages > 0 ? 'Unread' : "", " Bell Icon Pressed"),
    className: "bell-icon",
    icon: noOfNewMessages > 0 ? _atoms.Icon.Type.BellUnread : _atoms.Icon.Type.Bell,
    color: _atoms.Color.Transparent,
    backgroundColor: _atoms.Color.Transparent,
    iconColor: _atoms.Color.Grey3,
    iconSize: 24,
    onClick: onBellIconClick,
    width: 40,
    height: 40
  }), noOfNewMessages > 0 && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "bell-dot ".concat(isMoreThan9 ? "wider-number" : ""),
    style: additionalStyles
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: noOfNewMessages > 9 ? "9+" : noOfNewMessages,
    color: _atoms.Color.White,
    type: _atoms.Label.Type.SmallBody,
    className: "notifications-number"
  })));
};

exports.NotificationsBellIcon = NotificationsBellIcon;